import React, { useState } from 'react';

import { Box } from '../../components/Box';
import { ModelSelector } from '../../components/ModelSelector/ModelSelector';
import { useApolloClient } from '@apollo/client';
import { Guide } from '../../components/Guide/Guide';
import { useQueryParamSync } from '../../hooks/custom/use-query-param-sync';
import { useSectionLoader } from '../../hooks/custom/use-section-loader';
import { useSearchLoader } from '../../hooks/custom/use-search-loader';
import { useInitialData } from '../../hooks/custom/use-initial-data';
import { useScrollToTop } from '../../hooks/custom/use-scroll-to-top';
import { useDynamicMetadata } from '../../hooks/custom/use-dynamic-metadata';
import { useErrorMessageTracking } from '../../hooks/custom/use-error-message-tracking';
import { Switch, Route } from 'react-router-dom';

export interface FeatureAppStandaloneProps {
  baseUrl?: string;
  done?: (result?: unknown) => void;
}

export const FeatureAppStandalone: React.FC<
  FeatureAppStandaloneProps
> = ({}) => {
  const [hasInit, setHasInit] = useState(false);
  const { containerRef, scrollToTop } = useScrollToTop(50);

  useQueryParamSync(hasInit, scrollToTop);

  const client = useApolloClient();
  const { loadSection } = useSectionLoader(client, hasInit);
  useSearchLoader(client, hasInit);
  useErrorMessageTracking();

  useDynamicMetadata({
    hasInit,
  });

  const { loadInitialData, onReset } = useInitialData({
    setHasInit,
  });

  // Load initial data on mount if not already loaded (from SSR)
  React.useEffect(() => {
    loadInitialData();
  }, [loadInitialData]);

  return (
    <Box ref={containerRef}>
      <Switch>
        <Route exact path={`/`}>
          <ModelSelector loadSection={loadSection} />
        </Route>
        <Route path={`/:modelYear/:modelId/:section?`}>
          <Guide
            onReset={onReset}
            scrollToTop={scrollToTop}
            hasInit={hasInit}
          />
        </Route>
        <Route>
          <h1>Not found</h1>
        </Route>
      </Switch>
    </Box>
  );
};
